module.exports = __webpack_public_path__ + "static/media/Frame-piece-collection.05f535d4.png";